import type { GuideModuleSlug } from "../types/guide-content.types.ts"
import { filterAccessibleModules } from "./guide-permissions.ts"
import { LEARNING_AREAS } from "./learning-areas.ts"

/**
 * Replaces the earlier per-role module ordering (`Owner = everything`,
 * `PM = projects`, `Sales = leads`, …) — permissions are the only source of
 * truth for what a user sees, never a hardcoded role name. The order itself
 * follows Browse by Area's own declared order (`LEARNING_AREAS`), so
 * "the next thing to learn" and "the next area listed" never disagree,
 * de-duplicated since "projects" backs more than one area slot historically
 * and `start-here` always leads so a brand-new user is never pointed past it.
 */
const MODULE_ORDER: GuideModuleSlug[] = [
  "start-here",
  ...Array.from(new Set(LEARNING_AREAS.flatMap((area) => area.moduleSlugs)))
]

/**
 * The same order, narrowed to what this user's actual permissions grant —
 * the one list Continue Learning (and anything else picking "the next
 * accessible module") reads, so nobody is ever steered toward a module they
 * can't open.
 */
export const getAccessibleRecommendedModules = (
  pages: readonly string[] | null | undefined
): GuideModuleSlug[] => filterAccessibleModules(MODULE_ORDER, pages)
